export const getPlanPriceSubtitle = (type: "free" | "monthly" | "trial" | "enterprise") => {
  if (type === "trial") {
    return "w 30d Trial";
  }
  if (type === "free") {
    return "with sign-up";
  }
  if (type === "enterprise") {
    return "";
  }
  return "per month";
};
